import React from 'react';
import { FaTimes } from 'react-icons/fa';

import commonStyle from 'commonStyle';
import './index.css';


export default class Summary extends React.Component {
  state = {
    status: 'Upload in progress',
  }

  getFilesToUploadCount = (files = {}) => {
    let count = 0;

    for (let id in files) {
      const file = files[id];

      if (!file.uploaded && !file.cancelled) {
        count++;
      }
    }

    return count;
  }

  setStatus = (status) => this.setState({ status })

  render() {
    const { files, toggleView, onCancel, hideToggle, clearDownloaded } = this.props;

    const { status } = this.state;

    let filesCount = 0;

    if (!hideToggle) {
      filesCount = this.getFilesToUploadCount(files)
    }

    const isSingle = filesCount === 1;

    return (
      <div
        className={'uploader-container'}
      >
        <div
          className={'upload-info'}
          style={{ justifyContent: 'space-between' }}
        >
          {!hideToggle ?
            <h6>{filesCount} {isSingle ? 'file': 'files'} uploading</h6>
            :
            <h6>{status}</h6>
          }
          <div className='upload-info-cancel-container'>
            {!hideToggle && toggleView &&
              <h6
                onClick={toggleView}
              >
                view details
              </h6>
            }
            {!hideToggle && clearDownloaded &&
              <h6
                onClick={clearDownloaded}
              >
                clear completed files
              </h6>
            }
            <div
              className='upload-info-cancel'
              onClick={onCancel}
            >
              <h6>
                <FaTimes />
              </h6>
            </div>
          </div>
        </div>
        <div
          className={`uploader-line${filesCount > 0 ? ' uploader-line__loading' : ''}`}
        />
      </div>
    )
  }
}